import axios from "axios";

const axiosClient = axios.create({
  baseURL: `${process.env.REACT_APP_ECOMMERCE_BASE_URL}/api`, // Base API URL
  timeout: 9000, // Timeout limit
});

// Add request interceptors (e.g., Authorization tokens)
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosClient;
